module.exports = __webpack_public_path__ + "static/media/TimeUp.64e788b4.mp3";